import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
import { dedupeMealTags } from '../utils/mealTagUtils';
import {
  areMealIngredientsEqual,
  dedupeMealIngredients,
} from '../utils/mealIngredientUtils';
import { sortTagsBySequence } from '../utils/tagUtils';

const initialState = {
  externalId: uuidv4(),
  mealType: 'meal',
  isDailyFare: false,
  dailyFare: 'lunch',
  isHalal: false,
  isVeg: false,
  tags: [],
  meatType: 'NotApplicable',
  allergies: [],
  hasAlternativePreprationForRecipe: 'yes',
  mealImage: null,
  caloriesUnit: 'kcal',
  sizeUnit: 'grams',
  primaryIngredient: [],
  additionalIngredient: [],
  orderBeforeHours: 24,
  mealProvider: null,
};

const createMealSlice = createSlice({
  initialState: initialState,
  name: 'create-meal-slice',
  reducers: {
    updateMealType: (state, action) => {
      state.mealType = action.payload;
    },
    updateDailyFare: (state, action) => {
      state.dailyFare = action.payload;
    },
    updateIsHalal: (state, action) => {
      state.isHalal = action.payload;
    },
    updateIsVeg: (state, action) => {
      state.isVeg = action.payload;
    },
    addTag: (state, action) => {
      state.tags = sortTagsBySequence(
        dedupeMealTags([...state.tags, action.payload])
      );
    },
    setTags: (state, action) => {
      state.tags = sortTagsBySequence(dedupeMealTags(action.payload));
    },
    deleteTag: (state, action) => {
      const { english, nor, sequence } = action.payload;
      state.tags = state.tags.filter(
        (tag) =>
          !(
            tag.english === english &&
            tag.nor === nor &&
            tag.sequence === sequence
          )
      );
    },
    updateCaloryUnitType: (state, action) => {
      state.caloriesUnit = action.payload;
    },
    updateServingSizeUnitType: (state, action) => {
      state.sizeUnit = action.payload;
    },
    updateAllergiesState: (state, action) => {
      console.dir(state.allergies);
      if (state.allergies.find((item) => action.payload.id === item.id)) {
        state.allergies = state.allergies.filter(
          (item) => action.payload.id !== item.id
        );
      } else {
        state.allergies = [...state.allergies, action.payload];
      }
      console.log('Allergies:', state.allergies);
      console.dir(state.allergies);
    },
    updateHasAlternativeServingSelection: (state, action) => {
      state.hasAlternativePreprationForRecipe = action.payload;
    },
    updateMeatType: (state, action) => {
      state.meatType = action.payload;
    },

    addNewIngredient: (state, action) => {
      if (action.payload.type === 'primary') {
        state.primaryIngredient = dedupeMealIngredients([
          ...state.primaryIngredient,
          action.payload.data,
        ]);
      } else {
        state.additionalIngredient = dedupeMealIngredients([
          ...state.additionalIngredient,
          action.payload.data,
        ]);
      }
    },
    deleteItem: (state, action) => {
      console.log('deleteItem', action.payload);
      if (action.payload.type === 'primary') {
        state.primaryIngredient = state.primaryIngredient.filter(
          (item) => !areMealIngredientsEqual(item, action.payload.data)
        );
      } else {
        state.additionalIngredient = state.additionalIngredient.filter(
          (item) => !areMealIngredientsEqual(item, action.payload.data)
        );
      }
    },
    hasDailyFare: (state, action) => {
      state.isDailyFare = action.payload;
    },
    updateMealUploadedImage: (state, action) => {
      state.mealImage = action.payload;
    },
    deleteMealUploadedImage: (state, action) => {
      state.mealImage = null;
    },
    reset: () => {
      return { ...initialState, externalId: uuidv4() };
    },
    setMealBoxDataForUpdate: (state, action) => {
      console.log('setMealBoxDataForUpdate', action.payload);
      return { ...action.payload };
    },
    updateOrderBeforeHours: (state, action) => {
      state.orderBeforeHours = action.payload;
    },
    updateMealProvider: (state, action) => {
      console.log('updateMealProvider', action.payload);
      state.mealProvider = action.payload;
      console.log('updateMealProvider after', state.mealProvider);
    },
    duplicateThisMeal: (state) => {
      return { ...state, externalId: uuidv4() };
    },
  },
});

export const CreateMealAction = createMealSlice.actions;
export default createMealSlice;
